import script from "./RegistertestView.vue?vue&type=script&setup=true&lang=js"
export * from "./RegistertestView.vue?vue&type=script&setup=true&lang=js"

import "./RegistertestView.vue?vue&type=style&index=0&id=0f1a5d96&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f1a5d96"]])

export default __exports__